import styled from 'styled-components';

export const Wrap = styled.footer`
    font-family: Montserrat, sans-serif;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: 1.444;
    order: 999;
    position: relative;
    z-index: 1000;
`;

export const Button = styled.a`
    border-radius: 3px;
    border: 1px solid #fff;
    color: #fff;
    padding: 5px 8px;
    text-decoration: none;
    transition: border-color 0.15s ease-in-out, color 0.15s ease-in-out;

    &:hover {
        border-color: #faad19;
        color: #faad19;
    }
`;

export const Container = styled.div`
    background: #090928;
    color: #fff;
    padding: 20px 40px;
    white-space: nowrap;

    @media (min-width: 992px) {
        align-items: center;
        background: linear-gradient(137deg, rgb(255, 255, 255) 260px, transparent 260px), #090928;
        display: flex;
        height: 75px;
        justify-content: space-between;
        padding-bottom: 0;
        padding-top: 0;
    }
`;

export const Content = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    gap: 10px;
    text-align: center;

    @media (min-width: 992px) {
        flex-direction: row;
        gap: 40px;
        justify-content: flex-end;
    }
`;

export const Text = styled.div<FooterTextProps>`
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    gap: 10px;
    text-align: center;

    @media (min-width: 992px) {
        gap: 5px;
    }

    @media (min-width: ${({ $compact }) => ($compact ? 1200 : 992)}px) {
        flex-direction: row;
        gap: 100px;
        justify-content: flex-end;
    }
`;

export const Links = styled.div`
    display: flex;
    flex-direction: column;
    gap: inherit;

    @media (min-width: 992px) {
        flex-direction: row;
        gap: 20px;
    }
`;

export const Link = styled.a`
    color: #fff;
    display: block;
    position: relative;
    transition: color 0.15s ease-in-out;

    &:hover {
        color: #faad19;
    }

    @media (min-width: 992px) {
        &:not(:first-child):before {
            content: '|';
            position: absolute;
            left: -11px;
            top: 0;
        }
    }
`;

export const LogoContainer = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    padding-bottom: 20px;

    @media (min-width: 992px) {
        color: #000;
        padding-bottom: 0;
    }
`;

export const LogoPicture = styled.picture`
    display: block;
    line-height: 0;
`;

export const LogoBlack = styled.img`
    @media (max-width: 991px) {
        display: none;
    }
`;

export const LogoWhite = styled.img`
    @media (min-width: 992px) {
        display: none;
    }
`;

export const PortionMarking = styled.div`
    background-color: #006400;
    color: #ffff00;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    font-weight: 700;
    height: 16px;
    line-height: 16px;
    padding: 0 1rem;
    text-align: center;
`;

export const PoweredBy = styled.div`
    font-size: 12px;
    margin-right: 12px;
`;
